import {index_tipos_projecao_vendas} from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/Simulacao/Helpers";

export const cabecalhos = [
  {
    text: 'Período',
    value: 'periodo',
    style: { textAlign: 'center' },
    sempre_visivel: true
  },
  {
    text: 'Demanda Histórica',
    value: 'qtde_vendas',
    style: { textAlign: 'center', borderRight: '1px solid #ECECEC'},
    sempre_visivel: true,
    is_number: true,
  },
  {
    text: 'Previsto',
    value: 'padrao_systock_qtde',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.padrao_systock,
    is_number: true,
  },
  {
    text: 'Erro Absoluto',
    value: 'padrao_systock_erro_absoluto',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.padrao_systock,
    is_number: true,
  },
  {
    text: 'Erro Quadratrico',
    value: 'padrao_systock_erro_quadratrico',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.padrao_systock,
    is_number: true,
  },
  {
    text: 'Taxa',
    value: 'padrao_systock_taxa',
    style: { textAlign: 'center', borderRight: '1px solid #ECECEC'},
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.padrao_systock,
    is_number: true,
    sufix: '%'
  },
  {
    text: 'Previsto',
    value: 'suavizacao_exponencial_qtde',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.suavizacao_exponencial,
    is_number: true,
  },
  {
    text: 'Erro Absoluto',
    value: 'suavizacao_exponencial_erro_absoluto',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.suavizacao_exponencial,
    is_number: true,
  },
  {
    text: 'Erro Quadratrico',
    value: 'suavizacao_exponencial_erro_quadratrico',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.suavizacao_exponencial,
    is_number: true,
  },
  {
    text: 'Taxa',
    value: 'suavizacao_exponencial_taxa',
    style: { textAlign: 'center', borderRight: '1px solid #ECECEC'},
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.suavizacao_exponencial,
    is_number: true,
    sufix: '%'
  },
  {
    text: 'Previsto',
    value: 'media_aritmetica_simples_trimestre_qtde',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_aritmetica_simples_trimestre,
    is_number: true,
  },
  {
    text: 'Erro Absoluto',
    value: 'media_aritmetica_simples_trimestre_erro_absoluto',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_aritmetica_simples_trimestre,
    is_number: true,
  },
  {
    text: 'Erro Quadratrico',
    value: 'media_aritmetica_simples_trimestre_erro_quadratrico',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_aritmetica_simples_trimestre,
    is_number: true,
  },
  {
    text: 'Taxa',
    value: 'media_aritmetica_simples_trimestre_taxa',
    style: { textAlign: 'center', borderRight: '1px solid #ECECEC'},
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_aritmetica_simples_trimestre,
    is_number: true,
    sufix: '%'
  },
  {
    text: 'Previsto',
    value: 'media_aritmetica_simples_semestre_qtde',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_aritmetica_simples_semestre,
    is_number: true,
  },
  {
    text: 'Erro Absoluto',
    value: 'media_aritmetica_simples_semestre_erro_absoluto',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_aritmetica_simples_semestre,
    is_number: true,
  },
  {
    text: 'Erro Quadratrico',
    value: 'media_aritmetica_simples_semestre_erro_quadratrico',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_aritmetica_simples_semestre,
    is_number: true,
  },
  {
    text: 'Taxa',
    value: 'media_aritmetica_simples_semestre_taxa',
    style: { textAlign: 'center', borderRight: '1px solid #ECECEC'},
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_aritmetica_simples_semestre,
    is_number: true,
    sufix: '%'
  },
  {
    text: 'Previsto',
    value: 'media_aritmetica_simples_ano_qtde',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_aritmetica_simples_ano,
    is_number: true,
  },
  {
    text: 'Erro Absoluto',
    value: 'media_aritmetica_simples_ano_erro_absoluto',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_aritmetica_simples_ano,
    is_number: true,
  },
  {
    text: 'Erro Quadratrico',
    value: 'media_aritmetica_simples_ano_erro_quadratrico',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_aritmetica_simples_ano,
    is_number: true,
  },
  {
    text: 'Taxa',
    value: 'media_aritmetica_simples_ano_taxa',
    style: { textAlign: 'center', borderRight: '1px solid #ECECEC'},
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_aritmetica_simples_ano,
    is_number: true,
    sufix: '%'
  },
  {
    text: 'Previsto',
    value: 'media_geometrica_qtde',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_geometrica,
    is_number: true,
  },
  {
    text: 'Erro Absoluto',
    value: 'media_geometrica_erro_absoluto',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_geometrica,
    is_number: true,
  },
  {
    text: 'Erro Quadratrico',
    value: 'media_geometrica_erro_quadratrico',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_geometrica,
    is_number: true,
  },
  {
    text: 'Taxa',
    value: 'media_geometrica_taxa',
    style: { textAlign: 'center', borderRight: '1px solid #ECECEC'},
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_geometrica,
    is_number: true,
    sufix: '%'
  },
  {
    text: 'Previsto',
    value: 'media_movel_ponderada_qtde',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_movel_ponderada,
    is_number: true,
  },
  {
    text: 'Erro Absoluto',
    value: 'media_movel_ponderada_erro_absoluto',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_movel_ponderada,
    is_number: true,
  },
  {
    text: 'Erro Quadratrico',
    value: 'media_movel_ponderada_erro_quadratrico',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_movel_ponderada,
    is_number: true,
  },
  {
    text: 'Taxa',
    value: 'media_movel_ponderada_taxa',
    style: { textAlign: 'center', borderRight: '1px solid #ECECEC'},
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.media_movel_ponderada,
    is_number: true,
    sufix: '%'
  },
  {
    text: 'Previsto',
    value: 'mediana_qtde',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.mediana,
    is_number: true,
  },
  {
    text: 'Erro Absoluto',
    value: 'mediana_erro_absoluto',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.mediana,
    is_number: true,
  },
  {
    text: 'Erro Quadratrico',
    value: 'mediana_erro_quadratrico',
    style: { textAlign: 'center' },
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.mediana,
    is_number: true,
  },
  {
    text: 'Taxa',
    value: 'mediana_taxa',
    style: { textAlign: 'center', borderRight: '1px solid #ECECEC'},
    index_tipo_projecao_vendas: index_tipos_projecao_vendas.mediana,
    is_number: true,
    sufix: '%'
  },
];
